<template>
  <div>
    <BlocoFiltroPesquisa
      :nome-do-form="nomeDoForm"
      :botao-adicionar="false"
      @pesquisar="pesquisar"
    >
      <template #form>
        <div class="row">
          <div class="col-xs-12 col-sm-10 col-md-10 col-lg-10">
            <CampoGenerico
              id="descricaoAbreviada"
              label="Descrição Abreviada"
              :valor="filtro.descricaoAbreviada"
              @atualizar="filtro.descricaoAbreviada = $event"
            />
          </div>
          <div class="col-xs-12 col-sm-2 col-md-2 col-lg-2">
            <SelecionarSituacao
              id="ativo"
              :valor="filtro.ativo"
              @atualizar="filtro.ativo = $event"
            />
          </div>
        </div>
      </template>
    </BlocoFiltroPesquisa>
    <BlocoPaginadorPesquisa
      :total="total"
      :modo-resultado="modoResultado"
      @paginaAlterada="paginaAlterada"
      @modoAlterado="modoAlterado"
    />
    <BlocoResultadoPesquisa :total="total" :modo-resultado="modoResultado">
      <template #tabela><CidTabela :cids="cids" /></template>
      <template #fichas>
        <div
          v-for="cid in cids"
          :key="cid._id"
          class="col-xs-12 col-sm-6 col-md-4 col-lg-3"
        >
          <CidFicha :cid="cid" />
        </div>
      </template>
    </BlocoResultadoPesquisa>
  </div>
</template>

<script>
import { ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import BlocoFiltroPesquisa from '@/componentes/formulario/BlocoFiltroPesquisa'
import BlocoPaginadorPesquisa from '@/componentes/formulario/BlocoPaginadorPesquisa'
import BlocoResultadoPesquisa from '@/componentes/formulario/BlocoResultadoPesquisa'
import CampoGenerico from '@/componentes/formulario/CampoGenerico'
import SelecionarSituacao from '@/componentes/formulario/SelecionarSituacao'
import { useMenu } from '@/composables/useMenu'
import { usePesquisa } from '@/composables/usePesquisa'
import CidServico from '@/servicos/CidServico'

import CidFicha from './CidFicha'
import CidTabela from './CidTabela'

export default {
  components: {
    CidFicha,
    CidTabela,
    BlocoFiltroPesquisa,
    CampoGenerico,
    SelecionarSituacao,
    BlocoResultadoPesquisa,
    BlocoPaginadorPesquisa,
  },
  setup() {
    const router = useRouter()
    const route = useRoute()
    const cids = ref([])
    const servico = new CidServico()
    const nomeResultado = 'cids'
    const nomeDoForm = 'CidForm'
    const filtro = ref({
      descricaoAbreviada: '',
      ativo: '',
    })
    const pesquisa = usePesquisa({
      filtro,
      resultado: cids,
      servico,
      nomeResultado,
      nomeDoForm,
      cacheFormularioAtivo: true,
      onNovo: () => router.replace({ path: route.path + '/cadastro' }),
    })
    useMenu(33)
    return { cids, filtro, ...pesquisa }
  },
}
</script>
